var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"correlation-map"},[_c('div',{staticClass:"svg-frame"}),_c('v-btn',{attrs:{"x-small":""},on:{"click":_vm.toggleScale}},[_vm._v("Toggle Scale")]),_vm._v(" "+_vm._s(_vm.scaleLinear)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }